import React from 'react'
import {
    StyledBreachWallContent,
    StyledTitle,
    StyledMessage,
    StyledRegistrationInfo,
    StyledPackage,
    StyledButton,
} from './BreachWallContent.styled'
import { createLinkClickEvent } from '../../../../createLinkClickHandler'
import SubscriptionPackage, {
    SubscriptionPackageProps,
} from '../../../SubscriptionPackage/SubscriptionPackage'
import { AuthenticationProvider } from '../../../../../../user-registration/authentication/AuthenticationProvider'
import { BreachEvent } from '@news-mono/web-common'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { AuthenticationState } from '@news-mono/web-common'
import { THEWEST_ALL } from '../../../../../../user-registration/entitlements/common'

export interface BreachWallContentProps {
    title: string
    message: React.ReactNode
    cta: string
    subscriptionPackages?: SubscriptionPackageProps[]

    breachCreativeName: string
    breachDeal: string
    articleId: string | undefined
    onEvent: (event: BreachEvent) => void
}

export const BreachWallContent: React.FC<BreachWallContentProps> = ({
    title,
    message,
    cta,
    subscriptionPackages,
    articleId,
    breachCreativeName,
    breachDeal,
    onEvent,
}) => {
    const { entitlements, isLoggedIn } = useSelector<
        AppState,
        AuthenticationState
    >((state) => state.authentication)

    // a returning user is a user who has registered, logged in, and has not completed a purchase
    const returningUser = isLoggedIn && !entitlements?.includes(THEWEST_ALL)

    return (
        <AuthenticationProvider onEvent={onEvent}>
            {({ createBreachSubscribeClickEvent }) => (
                <StyledBreachWallContent>
                    <StyledRegistrationInfo>
                        <StyledTitle>{title}</StyledTitle>
                        <StyledMessage>{message}</StyledMessage>

                        <StyledButton
                            onClick={() => {
                                createLinkClickEvent(
                                    breachCreativeName,
                                    breachDeal,
                                    onEvent,
                                )()
                                createBreachSubscribeClickEvent({
                                    articleId,
                                    breachCreativeName,
                                    breachDeal,
                                    returningUser,
                                })()
                            }}
                        >
                            {cta}
                        </StyledButton>
                    </StyledRegistrationInfo>
                    <StyledPackage>
                        {subscriptionPackages &&
                            subscriptionPackages.map(
                                (subscriptionPackageItem, index) => {
                                    return (
                                        <SubscriptionPackage
                                            key={index}
                                            articleId={articleId}
                                            breachCreativeName={
                                                breachCreativeName
                                            }
                                            breachDeal={breachDeal}
                                            onEvent={
                                                subscriptionPackageItem.onEvent
                                            }
                                            ribbonTitle={
                                                subscriptionPackageItem.ribbonTitle
                                            }
                                            pretitle={
                                                subscriptionPackageItem.pretitle
                                            }
                                            heading={
                                                subscriptionPackageItem.heading
                                            }
                                            price={
                                                subscriptionPackageItem.price
                                            }
                                            packagePath={
                                                subscriptionPackageItem.packagePath
                                            }
                                            packageType={
                                                subscriptionPackageItem.packageType
                                            }
                                        />
                                    )
                                },
                            )}
                    </StyledPackage>
                </StyledBreachWallContent>
            )}
        </AuthenticationProvider>
    )
}
BreachWallContent.displayName = 'BreachWallContent'

export default BreachWallContent
